import React from 'react';

export const LabHelp = (
    <>
        <br></br>
        <div className="help-field">
            <div className="help-title">
                <h2>Join our community on the <a href="https://meltano.com/slack" target="_blank" rel="noreferrer">Meltano Slack</a> to get help and updates.</h2>
            </div>
        </div>
        <br></br>
        <hr></hr>
        <br></br>
        <div className="help-field">
            <div className="help-title">
                <h2>Further Reading & Links</h2>
            </div>
            <div className="pad_bot10">
                <a href="https://docs.meltano.com/" target="_blank" rel="noreferrer">Meltano Documentation</a>
            </div>
            <div className="pad_bot10">
                <a href="https://github.com/meltano/meltano-examples" target="_blank" rel="noreferrer">Meltano Examples</a>
            </div>
        </div>
    </>
)
